import React from 'react'
import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon'

const GlossarySvg = () => {
  return (
    <svg
      id="prefix__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox='0 0 67 49'
      xmlSpace='preserve'
      width='50px'
      height='50px'
    >
      <style>{'.prefix__st0{fill:#bac5d4}'}</style>
      <path
        className="prefix__st0"
        d="M23.5,2H8s0,0,0,0H6.2C3.9,2,2,3.9,2,6.2v15.9s0,0,0,0v3.8c0,1.5,1.2,2.6,2.6,2.6h20.4
        c1.5,0,2.6-1.2,2.6-2.6V6.2C27.7,3.9,25.8,2,23.5,2ZM26.4,6.2v13.3H8.6V3.3h14.8c1.6,0,2.9,1.3,2.9,2.9ZM6.2,3.3h1.1v16.3H4.6
        c-.5,0-1,.1-1.4.4V6.2c0-1.6,1.3-2.9,2.9-2.9ZM26.4,25.9c0,.8-.6,1.4-1.4,1.4H4.6c-.8,0-1.4-.6-1.4-1.4v-1.6s0,0,0,0v-2.2
        c0-.7.6-1.4,1.4-1.4h21.8v5.1Z"
      />
      <path
        className="prefix__st0"
        d="M13.8,15.8c0,0,.2,0,.2,0,.2,0,.5-.1.6-.4l.7-1.6h4.2l.7,1.6c.1.3.5.5.8.3.3-.1.5-.5.3-.8l-3.4-7.8
        c-.1-.2-.3-.4-.6-.4h0c-.3,0-.5.2-.6.4l-3.3,7.8c-.1.3,0,.7.3.8ZM17.4,9.1l1.6,3.6h-3.1l1.5-3.6Z"
      />
    </svg>
  )
}

export const GlossaryIcon = (props: AntdIconProps) => (
  <Icon component={GlossarySvg} {...(props as any)} />
)
